import { AutogenModelBreakthroughTransaction, AutogenRowBreakthroughTransaction } from "./autogen/AutogenModelBreakthroughTransaction";

export class ModelBreakthroughTransaction extends AutogenModelBreakthroughTransaction<RowBreakthroughTransaction> {
	constructor() {
		super(RowBreakthroughTransaction);
	}
}

export class RowBreakthroughTransaction extends AutogenRowBreakthroughTransaction {
}